import React from 'react';
import { CssBaseline, IconButton, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarKey, SnackbarProvider, useSnackbar } from 'notistack';
import { Provider } from 'react-redux';

import store from '@/store.ts';
import theme from '@/theme';

import { AuthFormProvider } from './authContext.tsx';

// Create a QueryClient instance
const queryClient = new QueryClient();

function SnackbarCloseButton({ snackbarKey }: { snackbarKey: SnackbarKey }) {
  const { closeSnackbar } = useSnackbar();

  return <IconButton onClick={() => closeSnackbar(snackbarKey)}></IconButton>;
}

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AuthFormProvider>
      <React.Suspense fallback="Loading...">
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
              <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
              >
                <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
              </SnackbarProvider>
            </Provider>
          </ThemeProvider>
        </StyledEngineProvider>
      </React.Suspense>
    </AuthFormProvider>
  );
};
